import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzRfnd3 } from './pages'

type TIdToPageMapWoofzEsa = Record<PageIdWoofzRfnd3, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_RFND3: TIdToPageMapWoofzEsa = {
  [PageIdWoofzRfnd3.SEX_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestionRfnd3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzRfnd3.DOG_AGE_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzRfnd3.DOG_BREED_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzRfnd3.URGE_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePageRfnd,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rfnd3/pages/urge/UrgePage'),
  },
  [PageIdWoofzRfnd3.COMMANDS_61_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion61Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion61Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion61Rfnd'
      ),
  },
  [PageIdWoofzRfnd3.COMMANDS_62_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion62Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion62Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion62Rfnd'
      ),
  },
  [PageIdWoofzRfnd3.COMMANDS_63_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion63Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion63Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/CommandsQuestion63Rfnd'
      ),
  },
  [PageIdWoofzRfnd3.URGE_RFND3_2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageRfndVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzRfnd3.POTTY_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestionRfnd,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/PottyQuestion'),
  },
  [PageIdWoofzRfnd3.BEHAVIOR_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestionRfnd,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzRfnd3.TRAINING_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/TrainingQuestion').then(
        (m) => ({
          default: m.TrainingQuestionRfnd,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/questions/TrainingQuestion'),
  },
  [PageIdWoofzRfnd3.PREPARE_FLOW_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/prepare-flow/PrepareFlowRfnd3'
      ).then((m) => ({
        default: m.PrepareFlowRfnd3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/prepare-flow/PrepareFlowRfnd3'
      ),
  },
  [PageIdWoofzRfnd3.DOG_STATISTICS_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/dog-statistics/DogStatisticsRfnd'
      ).then((m) => ({
        default: m.DogStatisticsRfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/questions/dog-statistics/DogStatisticsRfnd'
      ),
  },
  [PageIdWoofzRfnd3.EMAIL_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/email/EmailRfnd3').then((m) => ({
        default: m.EmailRfnd3,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rfnd3/pages/email/EmailRfnd3'),
  },
  [PageIdWoofzRfnd3.NEWSLETTER_URGE_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/email/components/NewsletterUrge'),
  },
  [PageIdWoofzRfnd3.LAST_CHANCE_OFFER_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/last-chance-offer/LastChanceOfferPageRfnd'
      ).then((m) => ({
        default: m.LastChanceOfferPageRfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/last-chance-offer/LastChanceOfferPageRfnd'
      ),
  },
  [PageIdWoofzRfnd3.SUBSCRIPTIONS_RFND3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzRfnd3.CANCEL_OFFER_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/subscriptions/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/subscriptions/CancelOffer'),
  },
  [PageIdWoofzRfnd3.CHAT_UPSELL_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzRfnd3.UPSELL_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rfnd3/pages/upsell/Upsell'),
  },
  [PageIdWoofzRfnd3.DOWNLOAD_RFND3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzRfnd3.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
